import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { DealThreadMessageStatus } from "@/src/graphql/generated";
import { AiMessageLoading } from "./loading";

export function formatReasoningDurationMs(durationMs?: number): string | null {
  if (
    durationMs === undefined ||
    durationMs === null ||
    Number.isNaN(durationMs) ||
    durationMs < 0
  ) {
    return null;
  }

  const durationSeconds = Math.max(1, Math.floor(durationMs / 1000));

  if (durationSeconds < 60) {
    return `${durationSeconds}s`;
  }

  return `${Math.floor(durationSeconds / 60)}m`;
}

export function AiMessageReasoningBlock(props: {
  reasoning?: string | null;
  durationMs?: number | null;
}) {
  const reasoning = props.reasoning?.trim();
  const durationMs = props.durationMs;
  const formattedDuration = formatReasoningDurationMs(durationMs ?? undefined);
  const [showReasoning, setShowReasoning] = useState(false);

  if (!reasoning) {
    return null;
  }

  return (
    <div className="space-y-1.5 w-full">
      <button
        type="button"
        onClick={() => setShowReasoning((prev) => !prev)}
        className="flex w-full items-center justify-between rounded-md px-1 py-0.5 hover:bg-gray-100"
      >
        <AiMessageLoading
          status={DealThreadMessageStatus.Thinking}
          text={formattedDuration ? `Thought for ${formattedDuration}` : "Thinking..."}
          animateText={!formattedDuration}
        />
        {showReasoning ? (
          <ChevronUpIcon className="h-4 w-4 text-concrete-500" />
        ) : (
          <ChevronDownIcon className="h-4 w-4 text-concrete-500" />
        )}
      </button>
      {showReasoning ? (
        <div className="rounded-md border border-concrete-200 bg-white px-3 py-2 text-sm text-gray-600 whitespace-pre-wrap">
          {reasoning}
        </div>
      ) : null}
    </div>
  );
}
